import {
  Datatype,
  IReference,
  IReferencePath,
  ReferencePathDirection,
  ReferenceType,
  WidgetType,
} from '@framework/engine';
import { uniq } from 'lodash';
import type {
  IMultiPreferenceWidget,
  IWidgetCascadeField,
} from '../IMultiPreferenceWidget';
import { computeMultiPreferenceTransformId } from '../computeMultiPreferenceTransforms';

export function getMultiPreferenceWidgetReferences(
  path: IReferencePath,
  widget: IMultiPreferenceWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.Array,
      itemsType: Datatype.Object,
      structure: [
        {
          type: ReferenceType.Widget,
          widgetType: WidgetType.Hidden,
          path: [
            ...path,
            { direction: ReferencePathDirection.Child, code: widget.code },
          ],
          id: `${widget.id}@id`,
          code: `id`,
          label: 'Preferenza',
          field: {
            type: Datatype.String,
            options:
              widget.cascade?.combinations.map(c => ({
                label: computeMultiPreferenceTransformId(c.values)!,
                value: computeMultiPreferenceTransformId(c.values)!,
              })) ?? undefined,
          },
        },
        ...(widget.cascade?.fields.map((field, i) =>
          createFieldColumnReference(widget, path, field),
        ) ?? []),
      ],
    },
  };
}

function createFieldColumnReference(
  widget: IMultiPreferenceWidget,
  path: IReferencePath,
  field: IWidgetCascadeField,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: WidgetType.Hidden,
    path: [
      ...path,
      { direction: ReferencePathDirection.Child, code: widget.code },
    ],
    id: `${widget.id}@field${field.index}`,
    code: `field${field.index}`,
    label: field.label ?? `Colonna ${field.index + 1}`,
    field: {
      type: Datatype.String,
      options: uniq(
        widget.cascade?.combinations.map(c => c.values[field.index]),
      ).map(v => ({
        label: v,
        value: v,
      })),
    },
  };
}
